import { useMemo } from 'react';
import { isPermitted, useJWT } from '../utils';
import { map } from 'lodash';

interface HookProps {
  // other params
  requirements: string[];
}

export const useCheckModulePermission = ({ requirements }: HookProps) => {
  const jwt = useJWT();

  const hasPermission = useMemo(() => {
    if (jwt.permissions) {
      const jwtPermission = map(jwt.permissions, (_, key) => key);
      return isPermitted(requirements, jwtPermission);
    }
    return false;
  }, [jwt.permissions, requirements]);

  return hasPermission;
};
